// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';

// Interne Module
import PropTypes from 'prop-types';

// Komponenten
import OverlayModal from '@/comp/overlayModal/overlayModal';

// Styles
import './travelTile.scss';

/**
 * Kacheln für Startseite, die verschieden genutzt werden können
 */
class TravelTile extends Component {
    state = {
        contactModal:
            this.props.linkType === 'modal' &&
            (this.props.name === 'changeSeatReservation' || this.props.name === 'changeExcursion'),
    };

    card() {
        return (
            <>
                {this.props.state === 'is-already-booked' ||
                this.props.state === 'editable' ||
                this.props.state === 'read-only' ? (
                    <i className="icon material-symbols-outlined">check</i>
                ) : (
                    <i className="icon material-symbols-outlined">{this.props.icon}</i>
                )}
                <div className="tile-card-body">
                    <div
                        className="title"
                        dangerouslySetInnerHTML={{
                            __html: this.props.headline && this.props.headline,
                        }}></div>
                    <div
                        className="description"
                        dangerouslySetInnerHTML={{ __html: this.props.description && this.props.description }}></div>
                    {this.props.state === 'loading' && (
                        <div>
                            <span></span>
                            <span></span>
                        </div>
                    )}
                </div>

                {(this.props.state === 'show' || this.props.state === 'alert') && (
                    <i className="arrow material-symbols-outlined">arrow_forward_ios</i>
                )}
                {this.props.state === 'editable' && <i className="material-symbols-outlined">edit</i>}
                {this.props.state === 'read-only' && <i className="material-symbols-outlined">visibility</i>}
            </>
        );
    }

    render() {
        if (this.props.state === 'is-already-booked') {
            return (
                <div
                    className={`tile-card-container ${this.props.name}
                    ${this.props.state} ${this.props.state === 'loading' ? 'lazy-load-background' : ''}`}>
                    {this.card()}
                </div>
            );
        } else if (this.props.linkType === 'modal') {
            return (
                <>
                    <div
                        className={`tile-card-container ${this.props.name} ${this.props.state} ${
                            this.props.name === 'apis' ? 'is-already-booked' : ''
                        }`}
                        onClick={() => this.setState({ modal: !this.state.modal })}>
                        {this.card()}
                    </div>
                    {this.state.modal && (
                        <OverlayModal
                            name={`${this.state.contactModal ? 'contact-modal' : this.props.name + '-details'}`}
                            displayName={this.props.name === 'tourguide' ? 'Kontaktdaten' : this.props.headline}
                            toggleModal={() => {
                                this.setState({ modal: !this.state.modal });
                            }}>
                            {this.props.children}
                        </OverlayModal>
                    )}
                </>
            );
        } else if (this.props.linkType === 'internal') {
            return (
                <Link
                    rel="noopener noreferrer"
                    to={'/' + this.props.link}
                    target={this.props.target !== '' ? '_blank' : ''}
                    className={`tile-card-container ${this.props.name}
                ${this.props.state} ${this.props.state === 'loading' ? 'lazy-load-background' : ''}`}>
                    {this.card()}
                </Link>
            );
        } else {
            return (
                <a
                    rel="noopener noreferrer"
                    href={this.props.link}
                    target={this.props.target !== '' ? '_blank' : ''}
                    className={`tile-card-container ${this.props.name}
                ${this.props.state} ${this.props.state === 'loading' ? 'lazy-load-background' : ''}`}>
                    {this.card()}
                </a>
            );
        }
    }
}

TravelTile.propTypes = {
    name: PropTypes.string,
    icon: PropTypes.string,
    headline: PropTypes.string,
    description: PropTypes.string,
    state: PropTypes.oneOf(['show', 'editable', 'alert', 'is-already-booked', 'read-only', 'loading']),
    link: PropTypes.string,
    linkType: PropTypes.oneOf(['internal', 'modal', 'external']),
    target: PropTypes.string,
};

export default TravelTile;
